import { Controller } from '@hotwired/stimulus'
import { toCurrency } from '../../utils/currency'

export default class ProductPageController extends Controller {
  static targets = [
    'submit',
    'total',
    'remove',
    'amount',
    'amountField',
    'container',
    'template'
  ]

  static values = {
    id: String,
    price: Number,
    total: Number,
    amount: { type: Number, default: 1 },
    modifiers: { type: Array, default: [] }
  }

  add (event) {
    if (this.canAddOption) {
      this.amountValue += 1
    }
  }

  remove (event) {
    if (this.canRemoveOption) {
      this.amountValue -= 1
    }
  }

  modifierChanged ({ detail: { id, total, options, isValid } }) {
    let modifierList = Array.from(this.modifiersValue)
    let modifier = modifierList.find(modifier => modifier.id === id)

    if (modifier === undefined) {
      modifierList = [...modifierList, { id, total, isValid, options }]
    } else {
      const index = modifierList.findIndex(modifier => modifier.id === id)
      modifier = { ...modifier, total, isValid, options }
      modifierList[index] = modifier
    }

    this.modifiersValue = Array.from(modifierList)
  }

  modifiersValueChanged () {
    this.totalValue = this.total
    this.updateUIOptions()
  }

  totalValueChanged () {
    this.totalTarget.textContent = toCurrency(this.totalValue)
  }

  amountValueChanged () {
    this.totalValue = this.total
    this.removeTarget.disabled = !this.canRemoveOption
    this.amountTarget.textContent = this.amountValue.toString()
    this.amountFieldTarget.value = this.amountValue.toString()
  }

  updateUIOptions () {
    this.submitTarget.disabled = !this.isValid
    this.containerTarget.innerHTML = ''

    this.optionIds.forEach(optionId => {
      const content = this.templateTarget.innerHTML.replace(/OPTION_ID/g, optionId)
      this.containerTarget.innerHTML += content
    })
  }

  get total () {
    return this.modifiersValue.reduce((acc, modifier) => acc + modifier.total, this.priceValue) * this.amountValue
  }

  get canAddOption () {
    return true
  }

  get canRemoveOption () {
    return this.amountValue > 1
  }

  get optionIds () {
    return this.modifiersValue.map(modifier => modifier.options.map(option => option.id)).flat(1)
  }

  get isValid () {
    return this.modifiersValue.every(modifier => modifier.isValid)
  }
}
